/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { CommonDropdown, RegularButton, CommonInput, ICommonDropdownOption, AlertAdapter } from 'pg-ui-library';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Chip } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import LeaveModuleService from 'src/services/leave-module.service';
import { exportToXLSX } from 'src/utils/xlsxConverter';
import { formatDateConverter } from 'src/utils/formatDateConvert';
import { DateTime } from 'luxon';
import { ReactComponent as OpenDropdownIcon } from '../../assets/open-dropdown-gray.svg';
import {
  Container,
  ScreenHeader,
  RightHeader,
  PageTitle,
  ActionCommomdropdown,
  CellSpan,
  CustomDropdownWrapper,
  DropdownButton,
  DropdownList,
  DropdownItem,
  ArrowIcon,
} from './styles';
import { LeaveConfimrationModal } from './leave-modal';
import { LeaveDeatilModal } from './leave-detail-modal';

export enum Leave {
  ALL_LEAVES = 'All Leaves',
  PENDING = 'Pending',
  WITHDRAWN = 'Withdrawn',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
}

const myLeaveOptions: ICommonDropdownOption[] = [
  {
    key: '0',
    label: Leave.ALL_LEAVES,
    value: '',
  },
  {
    key: '1',
    label: Leave.PENDING,
    value: Leave.PENDING,
  },
  {
    key: '2',
    label: Leave.APPROVED,
    value: Leave.APPROVED,
  },
  {
    key: '3',
    label: Leave.REJECTED,
    value: Leave.REJECTED,
  },
];

export enum LeaveAction {
  SET_TO_PENDING = 'Set to Pending',
  APPROVE = 'Approve',
  REJECT = 'Reject',
}

const leaveAction: ICommonDropdownOption[] = [
  {
    key: '0',
    label: 'Action',
    value: '',
  },
  {
    key: '1',
    label: LeaveAction.SET_TO_PENDING,
    value: 'Pending',
  },
  {
    key: '2',
    label: LeaveAction.APPROVE,
    value: 'Approved',
  },
  {
    key: '3',
    label: LeaveAction.REJECT,
    value: 'Rejected',
  },
];

const LeaveModule: React.FC = () => {
  const statusMapping: Record<
    string,
    { color: 'default' | 'primary' | 'secondary' | 'error' | 'success'; label: string; bgColor: string }
  > = {
    Rejected: { color: 'default', label: 'Rejected', bgColor: '#E74C3C' },
    Pending: { color: 'default', label: 'Pending', bgColor: '#E67E22' },
    Withdrawn: { color: 'default', label: 'Withdrawn', bgColor: '#7F8C8D' },
    Approved: { color: 'default', label: 'Approved', bgColor: '#6FC38A' },
  };

  const { t } = useTranslation();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState('');
  const [searchTerm, setsearchTerm] = useState('');
  const [statusTicket, setStatusTicket] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [status, setStatus] = useState('');
  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [selectedLeaves, setSelectedLeaves] = useState<any>([]);
  const [selectedLeave, setSelectedLeave] = useState<string>('');
  const isButtonEnabled = selectedRows.length > 0 && selectedLeave !== '';
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isOpenDetail, setIsOpenDetail] = useState<boolean>(false);
  const [leaveDetailSend, setLeaveDetailSend] = useState<boolean>();
  const companyId = '';
  const [statusChnageObj, setStatusChnageObj] = useState({});
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const LeaveTableColumns: GridColDef[] = [
    {
      headerName: 'Leave ID',
      headerClassName: 'CommonHeaderClass',
      field: 'leaveRequestId',
      minWidth: 150,
      renderCell: params => (
        <div>
          <CellSpan title={params.value} data-tag="allowRowEvents" onClick={() => leaveDetail(params.row)}>
            {params.value}
          </CellSpan>
        </div>
      ),
    },
    {
      headerName: 'Employee Name',
      headerClassName: 'CommonHeaderClass',
      field: 'employeeName',
      minWidth: 140,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Personnel Number',
      headerClassName: 'CommonHeaderClass',
      field: 'personnelNumber',
      minWidth: 150,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Company ID',
      headerClassName: 'CommonHeaderClass',
      field: 'companyId',
      minWidth: 110,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Start Date',
      headerClassName: 'CommonHeaderClass',
      field: 'startDate',
      minWidth: 120,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'End Date',
      headerClassName: 'CommonHeaderClass',
      field: 'endDate',
      minWidth: 120,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Leave Type',
      headerClassName: 'CommonHeaderClass',
      field: 'accrualId',
      minWidth: 120,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Days',
      headerClassName: 'CommonHeaderClass',
      field: 'length',
      minWidth: 100,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Created At',
      headerClassName: 'CommonHeaderClass',
      field: 'createdAt',
      minWidth: 150,
      sortable: true,
      filterable: false,
      renderCell: params => {
        const createdAt = params.value;
        const formattedDate = formatDateConverter(createdAt);
        return <span>{formattedDate}</span>;
      },
    },
    {
      headerName: 'Status',
      headerClassName: 'CommonHeaderClass',
      field: 'status',
      minWidth: 150,
      sortable: true,
      filterable: false,
      renderCell: params => {
        const status = params.value as string;
        const { color, label, bgColor } = statusMapping[status] || {
          color: 'default',
          label: 'Unknown',
          bgColor: '#9e9e9e',
        };
        return (
          <Chip
            label={label}
            variant="outlined"
            style={{
              backgroundColor: bgColor,
              fontSize: '12px',
              color: 'white',
              borderColor: 'transparent',
              textTransform: 'capitalize',
              borderRadius: '6px',
            }}
          />
        );
      },
    },
  ];

  const { isFetching, data, refetch } = useQuery(['leave-module'], async () => {
    const result = await LeaveModuleService.getLeaves({
      companyId,
      page,
      limit,
      search: searchTerm,
      sortBy,
      sortDirection,
      status,
    });
    return result;
  });

  const leaveDetail = (leave: any) => {
    setLeaveDetailSend(leave);
    setIsOpenDetail(true);
  };

  useEffect(() => {
    refetch();
  }, [status, searchTerm, page, limit, sortBy, sortDirection, refetch]);

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePerRowsChange = async (newLimit: number, newPage: number) => {
    setLimit(newLimit);
    setPage(newPage);
  };

  const onPageMetaChange = async (changes: any) => {
    const persentPage = changes.page + 1;
    if (persentPage > page) {
      handlePageChange(page + 1);
    }
    if (persentPage < page) {
      handlePageChange(page - 1);
    }
    if (changes.pageSize !== limit) {
      handlePerRowsChange(changes.pageSize, page);
    }
  };

  const onSortMetaChange = async (changes: any) => {
    setSortBy(changes[0].field as unknown as string);
    setSortDirection(changes[0].sort);
  };

  const formattedData = data?.items?.map((row: any, index: number) => ({
    ...row,
    id: row.id || index + 1,
  }));

  const exportToExcel = (): void => {
    if (!formattedData || formattedData.length === 0) {
      AlertAdapter('No data available to export', 'error');
      return;
    }

    const selectedLeavesForExport = formattedData.filter(leave => selectedRows.includes(leave.id));

    const leavesForExport = selectedLeavesForExport.map(leave => ({
      'Leave ID': leave.leaveRequestId,
      'Employee Name': leave.employeeName,
      'Personnel Number': leave.personnelNumber,
      'Company ID': leave.companyId,
      'Start Date': leave.startDate,
      'End Date': leave.endDate,
      'Leave Type': leave.accrualName,
      Days: leave.length,
      Reason: leave.reason,
      Comment: leave.comment,
      'Created At': DateTime.fromISO(leave.createdAt).toFormat('yyyy-MM-dd'),
      Status: leave.status,
    }));

    exportToXLSX(leavesForExport, 'selected-leaves', 'selected-leaves');
  };

  const [selectedOption, setSelectedOption] = useState<string>('');
  const isDropdownEnabled = selectedRows.length > 0;

  const handleDropdownChange = (value: string) => {
    setSelectedOption(value);
    setIsOpen(true);
    const statusChange = {
      leaveIds: selectedRows,
      status: value,
    };
    setStatusChnageObj(statusChange);
  };

  const onRowSelectionModelChange = (newSelectionModel: any) => {
    setSelectedRows(newSelectionModel);

    const leaves = newSelectionModel.map((id: string) => {
      const leave = data?.items?.find(item => item.id === id);
      return leave;
    });

    setSelectedLeaves(leaves);
  };

  return (
    <Container>
      <LeaveConfimrationModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        leaveStatusChange={statusChnageObj}
        refetch={refetch}
        setSelectedRows={setSelectedRows}
      />

      <LeaveDeatilModal
        isOpenDetail={isOpenDetail}
        setIsOpenDetail={setIsOpenDetail}
        leaveSend={leaveDetailSend}
        refetch={refetch}
        setSelectedRows={setSelectedRows}
      />

      <ScreenHeader>
        <PageTitle>Leave Requests</PageTitle>

        <RightHeader style={{ display: 'flex', alignItems: 'center' }}>
          <CommonInput
            id="searchQuery"
            name="searchQuery"
            placeholder="Search..."
            value={searchTerm}
            onChange={event => {
              let newValue = event.target.value;
              newValue = newValue.replace(/[',]/g, '');
              setsearchTerm(newValue);
            }}
            style={{
              width: '200px',
              marginRight: '10px',
              backgroundColor: 'white',
              color: 'black',
              border: '1px solid #ccc',
              borderRadius: '4px',
              margin: '0.5em',
              fontWeight: '500',
              maxHeight: '36px',
              padding: '10px',
            }}
            label=""
          />

          <CommonDropdown
            label=""
            id="statusTicket"
            name="statusTicket"
            options={myLeaveOptions}
            value={statusTicket}
            setValue={(value: string) => {
              setStatusTicket(value);
              setStatus(value);
            }}
            selectStyle={{
              width: '200px',
              marginRight: '10px',
              backgroundColor: 'white',
              color: 'black',
              border: '1px solid #ccc',
              borderRadius: '4px',
              margin: '0.5em',
              fontWeight: '500',
              maxHeight: '36px',
              padding: '5px',
            }}
          />

          <CustomDropdownWrapper ref={dropdownRef}>
            <DropdownButton
              disabled={!isDropdownEnabled}
              onClick={() => setDropdownOpen(!dropdownOpen)}
              style={{ padding: '8px 20px' }}
            >
              {'Action'}
              <OpenDropdownIcon
                style={{
                  fill: dropdownOpen && isDropdownEnabled ? 'white' : 'gray',
                  transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease, fill 0.3s ease',
                }}
              />
            </DropdownButton>

            {dropdownOpen && (
              <DropdownList>
                {leaveAction
                  .filter(option => option.value !== '')
                  .map(option => (
                    <DropdownItem key={option.key} onClick={() => handleDropdownChange(option.value)}>
                      {option.label}
                    </DropdownItem>
                  ))}
              </DropdownList>
            )}
          </CustomDropdownWrapper>

          <RegularButton onClick={exportToExcel} disabled={!isDropdownEnabled}>
            {t('global.form.export')}
          </RegularButton>
        </RightHeader>
      </ScreenHeader>
      <div>
        {formattedData && formattedData.length > 0 ? (
          <DataGrid
            rows={formattedData}
            columns={LeaveTableColumns}
            pagination
            paginationMode="server"
            onPaginationModelChange={state => {
              onPageMetaChange(state);
            }}
            onSortModelChange={state => {
              onSortMetaChange(state);
            }}
            onRowSelectionModelChange={onRowSelectionModelChange}
            rowSelectionModel={selectedRows}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[10, 20, 50]}
            rowCount={data?.meta.totalItems}
            loading={isFetching}
            disableColumnFilter
            checkboxSelection
            sx={{
              font: '14px Biotif',
              fontWeight: 'bold',
              '& .CommonHeaderClass': {
                color: '#9399B2',
                font: '16px Biotif',
                fontWeight: 'bold',
              },
              minHeight: '150px',
              background: '#fff',
            }}
          />
        ) : (
          <div style={{ minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            No Leaves to display.
          </div>
        )}
      </div>
    </Container>
  );
};

export default LeaveModule;
